// extracted by mini-css-extract-plugin
export var badge = "_t6-4";
export var selected = "_t6-1";
export var selectedOverlay = "_t6-5";
export var thumbnailButton = "_t6-0";
export var thumbnailFallback = "_t6-3";
export var thumbnailImage = "_t6-2";